<template>
<div style="width: 100%" v-if="employer" class="employer-page">
	<v-subheader>{{$t('employers.employers')}} > {{$t('employers.employer')}} #{{ $route.params.employerId }} </v-subheader>
	<v-container grid-list-lg>
		<v-card>
			<h3 class="caption-block">
				{{ $t('employers.header') }}
			</h3>
			<v-card-title primary-title>
				<v-layout>
					<v-flex md4>
						<v-text-field :label="$t('employers.name')"
							v-model="employer.name"
						/>
					</v-flex>
					<v-flex md4>
						<v-text-field :label="$t('employers.ico')"
							v-model="employer.ico"
						/>
					</v-flex>
					<v-flex md4>
						<v-text-field :label="$t('employers.dic')"
							v-model="employer.dic"
						/>
					</v-flex>
				</v-layout>
				<v-layout>
					<v-flex md4>
						<v-select
							:items="tituls1"
							v-model="employer.person_titul1"
							:label="$t('employers.person_titul1')"
						/>
					</v-flex>
					<v-flex md4>
						<v-select
							:items="tituls2"
							v-model="employer.person_titul2"
							:label="$t('employers.person_titul2')"
						/>
					</v-flex>
					<v-flex md4>
						<v-text-field :label="$t('employers.person_rodnyChisla')"
							v-model="employer.person_rodnyChisla"
						/>
					</v-flex>
				</v-layout>
				<v-layout>
					<v-flex md4>
						<v-text-field :label="$t('workers.firstname')"
							v-model="employer.person_firstname"
						/>
					</v-flex>
					<v-flex md4>
						<v-text-field :label="$t('workers.lastname')"
							v-model="employer.person_lastname"
						/>
					</v-flex>
					<v-flex md4>
						<v-select
							:items="genders"
							:label="$t('workers.gender')"
							v-model="employer.person_gender"
							item-text="name"
							item-value="key"
						/>
					</v-flex>
				</v-layout>
			</v-card-title>
		</v-card>
		<v-card class="address-block">
			<h3 class="caption-block">
				{{ $t('workers.address') }}
			</h3>
			<v-card-title primary-title>
				<address-group
					:main-label="$t('address.office_address')"
					:list-label="$t('address.work_address')"
					:main-address="employer.employer_office_address"
					:list-address="employer.employer_work_address"
					@createMultiple="createAddressMultiple"
					@update="updateAddressWithNotify"
					@createOne="createAddressOne"
					@delete="deleteAddressWithNotify"
				/>
			</v-card-title>
		</v-card>
		<v-layout d-flex justify-center align-content-center class="save-button">
			<v-tooltip top>
				<v-btn color="green lighten-1" class="white--text" slot="activator" @click="updateEmpl">
					<v-icon>save</v-icon>
					<span style="padding-left: 5px">{{$t('common.save')}}</span>
				</v-btn>
				<span>
					{{$t('employers.save_employer')}}
				</span>
			</v-tooltip>
		</v-layout>
	</v-container>
	<Loader v-if="isLoading" />
</div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { get } from 'lodash'
import AddressGroup from '../components/address-group/AddressGroup'
import Loader from '../components/Loader'
import { notify } from '../utils/notifications'

export default {
	data: vm => ({
		genders: [
			{ key: 'male', name: vm.$t('common.gender_male') },
			{ key: 'female', name: vm.$t('common.gender_female') },
		]
	}),
	components: {
		AddressGroup,
		Loader
	},
	created() {
		this.getEmployer()
	},
	methods: {
		...mapActions({
			updateEmployer: 'employers/updateEmployer',
			getEmployer: 'employers/getEmployer',
			createAddress: 'employers/createAddress',
			updateAddress: 'employers/updateAddress',
			deleteAddress: 'employers/deleteAddress'
		}),
		updateEmpl() {
			this.updateEmployer(this.employer).then(() => {
				this.$notify({
					...notify,
					text: this.$t('notifications.updated', {
						type: this.$t('workers.employer')
					})
				})
			})
		},
		createAddressMultiple(data) {
			this.createAddress({
				...data,
				addressable_type: 'employer_work_address'
			}).then(() => {
				this.$notify({
					...notify,
					text: this.$t('notifications.created', {
						type: this.$t('address.address')
					})
				})
			})
		},
		createAddressOne(data) {
			this.createAddress({
				...data,
				addressable_type: 'employer_office_address'
			}).then(() => {
				this.$notify({
					...notify,
					text: this.$t('notifications.created', {
						type: this.$t('address.address')
					})
				})
			})
		},
		updateAddressWithNotify(data) {
			this.updateAddress(data).then(() => {
				this.$notify({
					...notify,
					text: this.$t('notifications.updated', {
						type: this.$t('address.address')
					})
				})
			})
		},
		deleteAddressWithNotify(data) {
			this.deleteAddress(data).then(() => {
				this.$notify({
					...notify,
					text: this.$t('notifications.updated', {
						type: this.$t('common.deleted')
					})
				})
			})
		},
	},
	computed: {
		...mapState({
			employer: ({ employers }) => employers.detail,
			isLoading: ({ employers }) => employers.isLoadingDetail
		}),
		...mapGetters({
			tituls1: 'settings/tituls1',
			tituls2: 'settings/tituls2'
		})
	}
}
</script>

<style>
.employer-page .caption-block {
	font-size: 18px;
	text-align: center;
	padding-top: 10px;
}
.employer-page .address-block {
	margin-top: 10px;
}
.save-button {
	text-align: center;
	margin-top: 10px !important;
}
</style>

